<template>
  <div class="calcul">
    <div class="calculator-grid">
      <div class="output">
        <div class="previous-operand">{{ previousOperandTextElement }}</div>
        <div class="current-operand">{{ currentOperandTextElement }}</div>
      </div>
      <button
        @click="
          clear();
          updateDisplay();
        "
        class="span-two"
      >
        AC
      </button>
      <button
        @click="
          del();
          updateDisplay();
        "
      >
        DEL
      </button>
      <button
        @click="
          chooseOperation('÷');
          updateDisplay();
        "
      >
        ÷
      </button>
      <button
        @click="
          appendNumber('1');
          updateDisplay();
        "
      >
        1
      </button>
      <button
        @click="
          appendNumber('2');
          updateDisplay();
        "
      >
        2
      </button>
      <button
        @click="
          appendNumber('3');
          updateDisplay();
        "
      >
        3
      </button>
      <button
        @click="
          chooseOperation('*');
          updateDisplay();
        "
      >
        *
      </button>
      <button
        @click="
          appendNumber('4');
          updateDisplay();
        "
      >
        4
      </button>
      <button
        @click="
          appendNumber('5');
          updateDisplay();
        "
      >
        5
      </button>
      <button
        @click="
          appendNumber('6');
          updateDisplay();
        "
      >
        6
      </button>
      <button
        @click="
          chooseOperation('+');
          updateDisplay();
        "
      >
        +
      </button>
      <button
        @click="
          appendNumber('7');
          updateDisplay();
        "
      >
        7
      </button>
      <button
        @click="
          appendNumber('8');
          updateDisplay();
        "
      >
        8
      </button>
      <button
        @click="
          appendNumber('9');
          updateDisplay();
        "
      >
        9
      </button>
      <button
        @click="
          chooseOperation('-');
          updateDisplay();
        "
      >
        -
      </button>
      <button
        @click="
          appendNumber('.');
          updateDisplay();
        "
      >
        .
      </button>
      <button
        @click="
          appendNumber('0');
          updateDisplay();
        "
      >
        0
      </button>
      <button
        @click="
          compute();
          updateDisplay();
        "
        class="span-two"
      >
        =
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calcul",
  data: () => ({
    previousOperandTextElement: "",
    currentOperandTextElement: "",
    currentOperand: "",
    previousOperand: "",
    operation: undefined,
  }),
  methods: {
    clear() {
      (this.previousOperandTextElement = ""),
        (this.currentOperandTextElement = ""),
        (this.currentOperand = "");
      this.previousOperand = "";
      this.operation = undefined;
    },
    del() {
      this.currentOperand = this.currentOperand.toString().slice(0, -1);
    },
    appendNumber(number) {
      if (number === "." && this.currentOperand.includes(".")) return;
      this.currentOperand = this.currentOperand.toString() + number.toString();
    },
    chooseOperation(operation) {
      if (this.currentOperand === "") {
        this.operation = operation;
        return;
      }
      if (this.previousOperand !== "") {
        this.compute();
      }
      this.operation = operation;
      this.previousOperand = this.currentOperand;
      this.currentOperand = "";
    },
    compute() {
      let computation;
      const prev = parseFloat(this.previousOperand);
      const current = parseFloat(this.currentOperand);
      if (isNaN(prev) || isNaN(current)) return;
      switch (this.operation) {
        case "+":
          computation = prev + current;
          break;
        case "-":
          computation = prev - current;
          break;
        case "*":
          computation = prev * current;
          break;
        case "÷":
          computation = prev / current;
          break;
        default:
          return;
      }
      this.currentOperand = computation;
      this.operation = undefined;
      this.previousOperand = "";
    },
    getDisplayNumber(number) {
      const stringNumber = number.toString();
      const integerDigits = parseFloat(stringNumber.split(".")[0]);
      const decimalDigits = stringNumber.split(".")[1];
      let integerDisplay;
      if (isNaN(integerDigits)) {
        integerDisplay = "";
      } else {
        integerDisplay = integerDigits.toLocaleString("en", {
          maximumFractionDigits: 0,
        });
      }
      if (decimalDigits != null) {
        return `${integerDisplay}.${decimalDigits}`;
      } else {
        return integerDisplay;
      }
    },
    updateDisplay() {
      this.currentOperandTextElement = this.getDisplayNumber(
        this.currentOperand
      );
      if (this.operation != null) {
        this.previousOperandTextElement = `${this.getDisplayNumber(
          this.previousOperand
        )} ${this.operation}`;
      } else {
        this.previousOperandTextElement = "";
      }
    },
  },
};
</script>
<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
  font-family: Gotham Rounded, sans-serif;
  font-weight: normal;
}

.calcul {
  height: 90vh;
  width: 100vw;
  padding: 0;
  margin: 0;
  background: linear-gradient(to right, #00aaff, #00ff6c);
}

.calculator-grid {
  display: grid;
  justify-content: center;
  align-content: center;
  min-height: 90vh;
  grid-template-columns: repeat(4, 75px);
  grid-template-rows: minmax(120px, auto) repeat(5, 75px);
}

.calculator-grid > button {
  cursor: pointer;
  font-size: 2rem;
  border: 1px solid white;
  outline: none;
  background-color: rgba(255, 255, 255, 0.75);
}

.calculator-grid > button:hover {
  background-color: rgba(255, 255, 255, 0.9);
}

.span-two {
  grid-column: span 2;
}

.output {
  grid-column: 1 / -1;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  flex-direction: column;
  padding: 10px;
  word-wrap: break-word;
  word-break: break-all;
}

.output .previous-operand {
  color: rgba(255, 255, 255, 0.75);
  font-size: 1.5rem;
}

.output .current-operand {
  color: white;
  font-size: 2.5rem;
}
</style>